import _ from 'lodash';
import React from 'react';
import JSONPreview from '../../../components/common/JSONPreview';
import ExplainWithAIButton from './ExplainWithAIButton';
import { UserAvatarLive } from '../../../components/common/UserAvatarLive';
import NiceDate from '../../../components/common/NiceDate';

export function FragmentContent({ fragment }) {
  let extraContext = null;
  if(!_.isEmpty(fragment.sourceContext)) {
    let { createdBy, ... otherContext } = fragment.sourceContext;
    extraContext = <div className={'d-flex align-items-center'}>
      { createdBy ? <span className='ml-2 mr-2 zoom-75'><UserAvatarLive user={createdBy} /></span> : null }
      {_.isEmpty(otherContext) ? null : <JSONPreview value={otherContext} />}
    </div>
  }
  let extraNotes = null;
  if(!_.isEmpty(fragment.notes)) {
    extraNotes =
      <div className='d-flex mt-1 bg-light-secondary p-1 rounded'>
        <span className={'text-secondary monospace mt-1'}>{'Notes:'}</span>
       
        <div className='flex-grow-1'>
        {_.map(fragment.notes, (note, i) =>
          <div className={'d-flex align-items-center'} key={i}>
            <span className='ml-2 mr-2 zoom-75'><UserAvatarLive id={note.userId} /></span>
            <em style={{wordBreak: 'break-word'}}>{note.content}</em>&nbsp; <NiceDate t={note.createdAt} />
          </div>)}
        </div>
      </div>
  }

  if (fragment.type === 'image') {
    let urlOrImg = fragment.text || '';

    if (urlOrImg.startsWith('https://tmnaassetscs.scene7.com/')) {
      urlOrImg = <img className='border border-danger rounded-sm float-left mr-2' width={100} src={urlOrImg.replace(/wid=\d+/, 'wid=320')} alt={fragment.text} />;
    } else if (urlOrImg.startsWith('https://build.ford.com/dig/Ford/')) {
      urlOrImg = <img className='border border-danger rounded-sm float-left mr-2' width={100} src={urlOrImg.replace('/HD-FULL/', '/HD-TILE/')} alt={fragment.text} />;
    }

    return <div className='text-ellipsis' style={{ maxWidth: '600px', position: 'relative' }}>
      <a href={fragment.text} target='_blank'>{urlOrImg}</a>
      {extraContext}
      {extraNotes}
    </div>;
  } else {
    return <div className=''>
      <ExplainWithAIButton text={fragment.text} /> {fragment.text}
      {extraContext}
      {extraNotes}
    </div>;
  }
}
